import React, { useEffect, useState } from "react";
import "./premium-auth-section.css";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../util/api";

const PremiumAuthSection = ({ isLoggedIn }) => {

    const { User } = useContext(AuthContext);
    const [dashboardLink, setDashboardLink] = useState("/dashboard");


    useEffect(() => {

        if (!User) return;

        if (User.role === "doctor") {
            setDashboardLink("/lawyer-dashboard");

        }

        if (User.role === "patient") {
            setDashboardLink("/client-dashboard");

        }
        
    }, [User]);

    return (



        <section className="obx-law-auth-wrapper">
            <div className="obx-law-auth-card">

                <div className="obx-law-auth-content">
                    <h2 className="obx-law-auth-title">
                        {isLoggedIn
                            ? "Welcome Back to Your Legal Dashboard"
                            : "Connect with Trusted Legal Professionals"}
                    </h2>

                    <p className="obx-law-auth-subtitle">
                        {isLoggedIn
                            ? "Manage your cases, consultations, and professional activities in one secure place."
                            : "Join our platform to consult experienced lawyers, manage legal matters, and access professional legal services with confidence."}
                    </p>

                    <div className="obx-law-auth-actions">
                        {!isLoggedIn ? (
                            <>
                                <Link to="/register" className="obx-law-btn obx-law-btn-primary">
                                    Register Now
                                </Link>
                                <Link to="/login" className="obx-law-btn obx-law-btn-outline">
                                    Login
                                </Link>
                            </>
                        ) : (
                            <Link to={dashboardLink} className="obx-law-btn obx-law-btn-primary">
                                Go to Dashboard
                            </Link>
                        )}
                    </div>
                </div>

                <div className="obx-law-auth-accent"></div>
            </div>
        </section>

    );
};

export default PremiumAuthSection;